import React from 'react'
import { useGetCurrentUserQuery } from '../../core/api/UserApi'
import { useTranslation } from 'react-i18next'
import { AppMultiDropdownWithPagination } from '../../components/AppDropdown/AppMultiDropdownWithPagination'
import { IEdgeServers } from '../../core/api/dto/BuffetDishDto'
import { useGetStationsQuery } from '../../core/api/StationsApi'

interface StationEditListProps {
  withoutList?: boolean
  currentEdgeServers: IEdgeServers[]
  setCurrentEdgeServers: React.Dispatch<React.SetStateAction<IEdgeServers[]>>
  withoutBorder?: boolean
}

export const StationEditList = ({
  currentEdgeServers,
  setCurrentEdgeServers,
  withoutList,
  withoutBorder,
}: StationEditListProps) => {
  const { data: currentUser } = useGetCurrentUserQuery()
  const { t } = useTranslation()

  const onRemoveEdgeServerItem = (id: number) => () => {
    setCurrentEdgeServers((prev) => prev.filter((item) => item.id !== id))
  }

  return (
    <>
      <div className={!withoutList ? 'mt-10' : ''}>
        <AppMultiDropdownWithPagination<IEdgeServers, keyof IEdgeServers>
          label={'Станции'}
          value={currentEdgeServers}
          getterData={useGetStationsQuery}
          extraOptions={{
            main_source:
              currentUser?.userRoles.restaurant.source?.toString() || undefined,
          }}
          propToShowInInput={'guid'}
          propToShowInList={'name'}
          id="tags"
          border={!withoutBorder}
          fullWidth
          placeholder="Выбрать"
          onChange={setCurrentEdgeServers}
        />
      </div>
      {/* {!!currentEdgeServers.length && !withoutList && (
        <div className="app-input-wrap">
          <label>{t('Выбранные станции')}</label>
          <div className="choose-items-block full-width">
            {currentEdgeServers.map((item, index) => (
              <div className="choose-item" key={item.id} id={`tag-${index}`}>
                {item.name}
                <i
                  className="an-ico an-ico-close"
                  onClick={onRemoveEdgeServerItem(item.id)}
                />
              </div>
            ))}
          </div>
        </div>
      )} */}
    </>
  )
}
